import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-16 px-4 bg-spice-800 text-white" data-id="element-109">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-5 md:gap-8 text-center md:text-left" data-id="element-110">
        <div className="bg-spice-700 p-4 md:p-6 rounded-full flex-shrink-0" data-id="element-111">
          <ShieldCheck className="w-14 h-14 md:w-20 md:h-20 text-spice-300" data-id="element-112" />
        </div>
        <div data-id="element-113">
          <h2 className="text-3xl font-bold mb-3 md:mb-4 text-spice-100" data-id="element-114">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-300 via-white to-accent-300 font-black drop-shadow-lg" data-id="element-115">
              Garantía de 30 Días
            </span>
            : "ÁMALO O DEVOLVELO" — 100% Satisfacción
          </h2>
          <p className="text-lg text-spice-200/90 leading-relaxed" data-id="element-116">
            Si este no es el recurso más completo y accionable que hayas visto
            para empezar a vender condimentos caseros, simplemente escribime y
            te devuelvo el 100% de tu dinero. Sin preguntas. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}